import { rowFilterService } from './row_filter_service';
import { columnFilterService } from './column_filter_service';
import { searchService } from './search_service';
import { dataService } from './data_service';
import { tableService } from './table_service';

class UiService {
  constructor() {
    this._headerHeight = 140; // xyz px should be the apps header height
    this._systemTopBarHeight = 100; // just a guess =|
  }

  init() {
    tableService.createTable(
      dataService.headers,
      dataService.rowsWithoutHeader,
    );
    columnFilterService.setupTooltip();

    if (typeof window.onorientationchange != 'undefined') {
      window.onorientationchange = this.onOrientationChange;
    }

    $(window).resize(this.onOrientationChange);

    this.onOrientationChange();
  }

  onOrientationChange() {
    // Assume landscape orientation first
    let width = $(window).width() + 'px';
    let height =
      $(window).height() - this._headerHeight + this._systemTopBarHeight + 'px';

    // Check for portrait orientation
    if (window.orientation == 0 || window.orientation == 180) {
      // Swap values
      [width, height] = [height, width];
    }

    // Overwrite max values
    let container = document.getElementById('data-table-container');
    container.style.maxWidth = width;
    container.style.maxHeight = height;
  }

  closeModals() {
    $.modal.close();
    columnFilterService.close();
  }

  updateTable() {
    let data = rowFilterService.applySelectedFiltersToData();
    data = searchService.applySearchToData(data);
    let {
      headerData,
      bodyData,
    } = columnFilterService.applySelectedFiltersToData(data);
    tableService.updateTable(bodyData, headerData);

    columnFilterService.updateFiltersCount();
    rowFilterService.updateFiltersCount();
  }

  applyChangedRegion() {
    searchService.clear();
    columnFilterService.clearAllSelectedFilters();
    rowFilterService.clearAllSelectedFilters();
    this.updateTable();
  }

  applyDefaultTableSort() {
    tableService.sortTable(0, 'asc');
  }
}

export let uiService = new UiService();
